export default {
  chatEndedLabel: 'Chat has ended',
  chatDeletedLabel: 'Sorry, this chat no longer exists.',
  chatConversationHasMoved: 'Conversation has moved',
};
